import { motion } from 'framer-motion';
import { JOBS, SAFETY, PHASES } from './data';

// HOME — jobsite ledger / daily-log feel. NOT a parallax construction hero. Industrial blueprint stripes,
// stamped job-card chips, big jobsite KPI numbers.
export default function Home({ setPage }) {
  return (
    <div className="bg-[#D9D4CC] text-[#1F2126]">
      {/* JOBSITE BANNER STRIP */}
      <section className="bg-[#FF7A1A] text-[#1F2126] py-2 mt-16 border-y-[3px] border-[#1F2126] overflow-hidden">
        <div className="flex gap-12 whitespace-nowrap font-mono text-[10px] tracking-[0.32em] uppercase">
          {Array(2).fill(0).map((_, i) => (
            <div key={i} className="flex gap-12 shrink-0">
              <span>● Jobsite stand-down · 7:00am ●</span><span>● 188,000 hrs injury-free ●</span><span>● EMR 0.62 ●</span><span>● Bonded $25M ●</span><span>● OSHA-30 crews ●</span>
            </div>
          ))}
        </div>
      </section>

      {/* JOB-CARD HERO */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 pt-14 pb-12">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 items-end">
          <div>
            <div className="bg-[#1F2126] text-[#FF7A1A] inline-block px-3 py-1 font-mono text-[10px] tracking-[0.32em] uppercase mb-5">— Yard / Job board —</div>
            <h1 className="font-serif text-[60px] sm:text-[100px] lg:text-[150px] leading-[0.86] tracking-[-0.02em] text-[#1F2126]">
              Build it<br /><span className="italic text-[#FF7A1A]">on the level.</span><br /><span className="text-[#1F2126]/55">On time.</span>
            </h1>
            <p className="font-sans text-base lg:text-lg text-[#1F2126]/70 mt-6 max-w-md leading-[1.6]">A 38-person GC. 92 active subs. Commercial, residential, and civic builds across the tri-state area since 2002. Bonded. OSHA-30 crews.</p>
            <div className="mt-9 flex flex-wrap gap-4">
              <button onClick={() => setPage('bid')} data-testid="iw-home-cta" className="bg-[#1F2126] text-[#FF7A1A] px-7 py-3.5 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#FF7A1A] hover:text-[#1F2126] transition-colors">Request a bid →</button>
              <button onClick={() => setPage('jobs')} className="font-mono text-[10px] tracking-[0.32em] uppercase border-2 border-[#1F2126] text-[#1F2126] px-7 py-3 hover:bg-[#1F2126] hover:text-[#FF7A1A] transition-colors">Open jobs ledger →</button>
            </div>
          </div>
          {/* JOBSITE TICKET CARD */}
          <motion.div initial={{ opacity: 0, rotate: -2, y: 20 }} animate={{ opacity: 1, rotate: -1.5, y: 0 }} transition={{ duration: 0.9 }} className="bg-[#FAFAF6] border-2 border-[#1F2126] p-7 relative shadow-[0_30px_70px_rgba(31,33,38,0.18)]">
            <div className="absolute -top-3 -right-3 bg-[#FF7A1A] text-[#1F2126] px-3 py-1 font-mono text-[10px] tracking-[0.32em] uppercase rotate-3 border-2 border-[#1F2126]">— Active —</div>
            <div className="flex items-baseline justify-between font-mono text-[10px] tracking-[0.3em] uppercase border-b-2 border-[#1F2126] pb-2"><span className="text-[#FF7A1A]">— Job IW-2025-118 —</span><span>Day 412 / 668</span></div>
            <p className="font-serif italic text-2xl mt-4">Hudson Valley residence</p>
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#1F2126]/55 mt-1">Ground-up · 11,400 sqft</p>
            <div className="mt-5 grid grid-cols-2 gap-3 font-mono text-[10px] tracking-[0.22em] uppercase text-[#1F2126]/65">
              <div><p>Crew on site</p><p className="font-sans text-2xl normal-case tracking-normal text-[#1F2126] mt-1">22</p></div>
              <div><p>Sub trades</p><p className="font-sans text-2xl normal-case tracking-normal text-[#1F2126] mt-1">14</p></div>
              <div><p>Schedule</p><p className="font-sans text-base normal-case tracking-normal text-[#1F2126] mt-1">+2 days</p></div>
              <div><p>Punch open</p><p className="font-sans text-2xl normal-case tracking-normal text-[#FF7A1A] mt-1">82</p></div>
            </div>
            <button onClick={() => setPage('jobs')} className="mt-5 w-full bg-[#1F2126] text-[#FF7A1A] py-3 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#FF7A1A] hover:text-[#1F2126] transition-colors">Open daily log →</button>
          </motion.div>
        </div>
      </section>

      {/* SAFETY KPI STRIP */}
      <section className="bg-[#1F2126] text-[#D9D4CC]">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid md:grid-cols-4 divide-x divide-[#2A2D33]">
          {SAFETY.map(s => (
            <div key={s.kpi} className="px-6 py-8">
              <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FF7A1A]">{s.kpi}</p>
              <p className="font-serif text-5xl text-[#D9D4CC] mt-2">{s.v}</p>
              <p className="font-mono text-xs text-[#D9D4CC]/55 mt-2">{s.n}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FIVE PHASES — punch-list */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1F2126]/65 mb-7">— Five phases · How we run a job —</p>
        <div className="space-y-3">
          {PHASES.map((p, i) => (
            <motion.article key={p.code} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }} className="grid lg:grid-cols-[120px_240px_1fr_120px] gap-4 lg:gap-8 items-baseline border-2 border-[#1F2126] bg-[#FAFAF6] px-6 py-5">
              <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FF7A1A]">Phase {p.code}</p>
              <h3 className="font-serif italic text-2xl text-[#1F2126]">{p.t}</h3>
              <p className="font-sans text-sm text-[#1F2126]/65 leading-[1.65]" dangerouslySetInnerHTML={{ __html: p.d }} />
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1F2126]/55 lg:text-right">[STD] ✓</p>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
